// Mirrors backend app/utils/search_domains.py, which stays the authority.
export const MAX_SEARCH_DOMAINS = 20;

const HOST_RE = /^(\*\.)?([a-z0-9-]+\.)+[a-z0-9-]{2,}$|^\*\.[a-z0-9-]{2,}$/;

export const normalizeSearchDomain = (raw: string): string | null => {
  const value = raw.trim();

  if (!value) return null;

  const withoutScheme = value.replace(/^[a-z][a-z0-9+.-]*:\/\//i, '').replace(/^\/\//, '');
  const [hostAndPath] = withoutScheme.split(/[?#]/);
  const slash = hostAndPath.indexOf('/');
  let host = (slash === -1 ? hostAndPath : hostAndPath.slice(0, slash)).toLowerCase();
  const path = slash === -1 ? '' : hostAndPath.slice(slash).replace(/\/+$/, '');

  host = host.replace(/:\d+$/, '');

  if (host.startsWith('www.')) host = host.slice(4);

  if (!HOST_RE.test(host)) return null;

  return `${host}${path}`;
};

// Users paste lists from emails and docs, so accept any common separator.
export const splitDomainInput = (raw: string): string[] =>
  raw.split(/[\s,;]+/).filter(Boolean);
